/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import { connect } from 'react-redux';
import {
  resultCardId,
  hyphenate,
  workPackageStateCharacter
} from '../../utils/string';
import { openDetailCard } from '../../utils/sprintHelpers';
import {
  updateWorkPackageLevelApiCall,
  orphanChildren
} from '../../actions/workPackageActions';

const WorkPackage = ({ workPackage }) => (
  <div>
    <div key={workPackage.id} className="unfinished-results-list">
      <div className="ur-check-and-title">
        <div className="ur-label-checkbox">
          <a
            onClick={() => openDetailCard(workPackage)}
            style={{ marginLeft: '0px' }}
          >
            {workPackage.result_type
              ? resultCardId(workPackage)
              : `O${workPackage.id}`}
          </a>
        </div>
        <div className="feature-name" style={{ paddingRight: '15px' }}>
          {workPackage.name}
        </div>
      </div>
      <div className="right ur-vrs-state">
        <span className={`icon ur-state ${hyphenate(workPackage.state || '')}`}>
          {workPackageStateCharacter(workPackage)}
        </span>
      </div>
    </div>
  </div>
);

const OrphanChildrenModal = ({
  children,
  payload,
  workPackage,
  orphanChildren,
  updateWorkPackageLevelApiCall,
  handleModalClose
}) => {
  const handleConfirmation = () => {
    const workPackageIds = children.map((child) => child.id);
    orphanChildren(workPackageIds);
    updateWorkPackageLevelApiCall(workPackage, payload);
    handleModalClose();
  };

  return (
    <div className="detail-modal orphan-children-modal">
      <div className="modal-dialog">
        <div className="modal-content orphan-children-modal">
          <div className="ur-modal-header">
            <div className="ur-modal-header-title">
              Changing this work package's level will orphan these children.
            </div>
          </div>
          <div className="modal-body">
            {children.map((child) => (
              <WorkPackage key={child.id} workPackage={child} />
            ))}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default ur-cancel"
              onClick={handleModalClose}
            >
              CANCEL
            </button>
            <button
              type="button"
              className="btn btn-primary ur-continue"
              onClick={handleConfirmation}
            >
              CONTINUE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { orphanChildren, updateWorkPackageLevelApiCall })(
  OrphanChildrenModal
);
